// extracted by mini-css-extract-plugin
export default {"box":"Box_box__bOFIU","icon":"Box_icon__xcpgC","text":"Box_text__O4ywe","title":"Box_title__LS+It","description":"Box_description__VjVs-"};